'use client';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { BASE_FILE_URL, COLORS } from '@/common/constants';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Link from 'next/link';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useTranslations } from 'next-intl';
import { twMerge } from 'tailwind-merge';

const TinTongHop = (props) => {
  const { crawlPostss } = props;
  const router = useRouter();
  const t = useTranslations('');
  const pathname = usePathname();
  const params = useSearchParams();
  const mainRssPostss = get(crawlPostss, 'results', []);

  const totalPages = crawlPostss.totalPages || 0;
  const currentPage = crawlPostss.page || 1;

  function cleanCDATA(content) {
    return content
      ?.replace(/^<!\[CDATA\[/, '') // bỏ đầu CDATA
      .replace(/\]\]>$/, '') // bỏ cuối CDATA
      .trim();
  }

  const handleChangePage = (page) => {
    const newParams = new URLSearchParams(params);
    newParams.set('page', page);
    router.push(`${pathname}?${newParams.toString()}`);
  };

  return (
    <>
      <h1 className={twMerge('text-xl font-bold mb-3', COLORS.primary)}>Danh sách tin tức tổng hợp</h1>
      <div className="mb-8 flex flex-wrap items-center justify-start space-x-3">
        {!isEmpty(mainRssPostss) ? (
          <div className="flex flex-wrap justify-between  pb-2">
            {mainRssPostss.map((posts) => (
              <article
                key={posts.id}
                className="md:w-[32%] w-full mb-4 border border-gray-300 
                                        rounded-sm overflow-hidden bg-white flex flex-col">
                <div className="px-3 py-2 flex flex-col justify-between flex-grow">
                  <div className="flex flex-col">
                    <h3 className={twMerge('text-md font-semibold mb-2 transition-colors line-clamp-2', COLORS.greenLightHover)}>
                      <Link className="rss-title" href={posts?.link} target="_blank" rel="noopener noreferrer">
                        {posts.title}
                      </Link>
                    </h3>
                    <div
                      className="text-base leading-relaxed space-y-4 max-w-none text-[13px]
                                                     text-gray-500 italic  customer-summary"
                      dangerouslySetInnerHTML={{ __html: cleanCDATA(posts?.summary) }}
                    />
                  </div>

                  <div className="text-gray-500 text-xs mb-3 flex justify-between items-center italic">
                    <div className="mr-7 mt-2">
                      <ClockCircleOutlined className="mr-1" />
                      {new Date(posts.pubDate).toLocaleDateString('vi-VN')}
                    </div>

                    <div>
                      <img className="h-[20px]" src={`${BASE_FILE_URL}/${posts?.brandLogoUrl}`} />
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <p className="text-md font-normal text-black mb-3 ">{t('news.noData')}</p>
        )}

        {totalPages > 1 && (
          <div className="mt-4 flex flex-wrap justify-center space-x-2 w-full">
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter((page) => {
                return (
                  page <= 3 || // 3 đầu
                  page > totalPages - 3 || // 3 cuối
                  (page >= currentPage - 1 && page <= currentPage + 1) // xung quanh trang hiện tại
                );
              })
              .reduce((acc, page, i, arr) => {
                if (i > 0 && page - arr[i - 1] > 1) {
                  acc.push('ellipsis-' + i); // Dùng key khác biệt
                }
                acc.push(page);
                return acc;
              }, [])
              .map((item) => {
                if (typeof item === 'string' && item.startsWith('ellipsis')) {
                  const middle = Math.floor(totalPages / 2);
                  return (
                    <button
                      key={item}
                      onClick={() => handleChangePage(middle)}
                      className="px-3 py-1 border rounded bg-white text-gray-500 border-gray-300">
                      ...
                    </button>
                  );
                } else {
                  return (
                    <button
                      key={item}
                      onClick={() => handleChangePage(item)}
                      className={`px-3 py-1 border rounded ${
                        currentPage === item ? 'bg-red-600 text-white' : 'bg-white text-gray-700 border-gray-300'
                      }`}>
                      {item}
                    </button>
                  );
                }
              })}
          </div>
        )}
      </div>
    </>
  );
};

export default TinTongHop;
